import { NgModule } from '@angular/core';
import { RippleDirective } from './ripple-effect.directive';
var RippleModule = (function () {
    function RippleModule() {
    }
    RippleModule.forRoot = function () {
        return { ngModule: RippleModule, providers: [] };
    };
    return RippleModule;
}());
export { RippleModule };
RippleModule.decorators = [
    { type: NgModule, args: [{
                declarations: [RippleDirective],
                exports: [RippleDirective]
            },] },
];
/** @nocollapse */
RippleModule.ctorParameters = function () { return []; };
//# sourceMappingURL=ripple.module.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/ripple/ripple.module.js
// module id = ../../../../angular-bootstrap-md/ripple/ripple.module.js
// module chunks = 3